import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { BOOKING_URL, IMG } from "../data/content";

const FinalCta = () => (
    <section
        data-testid="final-cta-section"
        className="ihcc-grain relative overflow-hidden bg-heritage-ink py-28 md:py-44"
    >
        <div className="absolute inset-0">
            <img
                src={IMG.lanterns}
                alt=""
                aria-hidden="true"
                className="h-full w-full object-cover opacity-25"
                loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-heritage-ink via-heritage-ink/70 to-heritage-ink" />
        </div>

        <div className="relative z-10 mx-auto max-w-4xl px-5 text-center md:px-10">
            <Reveal>
                <Eyebrow dark>Don't Just Visit — Experience IHCC</Eyebrow>
                <h2 className="mt-8 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-heritage-parchment sm:text-5xl lg:text-7xl">
                    Discover Indian Heritage{" "}
                    <em className="text-heritage-gold">in Penang</em>
                </h2>
                <p className="mx-auto mt-8 max-w-xl text-base leading-relaxed text-heritage-parchment/70">
                    The stories, objects, traditions and experiences of Indian heritage are waiting
                    inside a heritage shophouse on Lebuh Pantai — seven chapters, one unforgettable
                    visit.
                </p>
            </Reveal>
            <Reveal delay={0.15}>
                <div className="mt-12 flex flex-col items-center gap-5">
                    <a
                        href={BOOKING_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="final-book-tickets-button"
                        className="group inline-flex items-center gap-3 rounded-full bg-heritage-terra px-10 py-5 font-mono text-xs uppercase tracking-[0.28em] text-heritage-parchment transition-all duration-300 hover:scale-[1.04] hover:bg-heritage-vermilion"
                    >
                        Book Tickets Online
                        <ArrowUpRight
                            size={16}
                            className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                        />
                    </a>
                    <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-heritage-parchment/45">
                        Secure e-tickets by{" "}
                        <a
                            href="https://staymii.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="final-staymii-etickets-link"
                            className="text-heritage-gold/80 underline-offset-4 transition-colors hover:text-heritage-gold hover:underline"
                        >
                            StayMii
                        </a>{" "}
                        · Booked via indianheritagegalleryandculturalcentre.com
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default FinalCta;
